/**
 * Central entry points for editor commands invoked from the menubar, context menus, and
 * (later) keyboard shortcuts. Replace no-op bodies with real behavior as features land.
 */

export function runFreezeSelected(): void {
  // TODO: freeze selected text/objects (context menu, ⌘/Ctrl+F).
}
